export const secToMin = sec => (sec * 0.0166667).toFixed(2);
export const metersToKm = meters => (meters * 0.001).toFixed(2);
export const toKobo = amount => amount * 100;
export const toNaira = amount => amount / 100;

export const checkNumber = (mobile, mobileCode = '+234') =>
  mobile.charAt(0) === '0'
    ? `${mobileCode}${mobile.slice(1)}`
    : `${mobileCode}${mobile}`;
